import * as constants from '../constants';

const INITIAL_STATE = {
    language: 'en',
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.SETTINGS_CHANGE_LANGUAGE:
            return Object.assign({}, state, {language: action.payload.language});
    }
    return state;
}
